<template>
   <!-- wrap with a div to prevent outside elements interfering -->
   <div>
      <!-- Header -->
      <button
         :id="`acc-btn-${name}`"
         class="w-full"
         data-cy="accordion-btn"
         :class="isExpanded ? buttonOpenClasses : buttonClosedClasses"
         :aria-expanded="isExpanded"
         :aria-controls="`acc-content-${name}`"
         @click="toggleExpand"
      >
         <div class="flex w-full items-center justify-between">
            <span class="flex-1" :class="{ 'order-1': iconPositionLeft }">
               <slot name="header"></slot>
            </span>
            <PlusMinusToggle
               v-if="usePlusMinusIcon"
               :class="[
                  { 'ml-6 md:ml-10 lg:ml-12 xl:ml-16': !iconPositionLeft },
                  { 'mr-6': iconPositionLeft },
                  { 'size-4': smallerIcon },
                  { 'size-6': !smallerIcon },
               ]"
               class="shrink-0"
               :isOpen="isExpanded"
            />
            <IconToggleArrow
               v-else
               class="shrink-0 fill-current text-current"
               :class="[
                  { 'ml-1': !iconPositionLeft },
                  { 'mr-2': iconPositionLeft },
                  { 'size-3': smallerIcon },
                  { 'size-4': !smallerIcon },
               ]"
               :style="`transform: rotate(${isExpanded ? '90' : '0'}deg); transition: transform 0.45s ease-in-out;`"
            />
         </div>
      </button>
      <!-- Content -->
      <transition name="expanded">
         <div v-show="isExpanded" :id="`acc-content-${name}`" :aria-hidden="!isExpanded" class="w-full">
            <slot name="content"></slot>
         </div>
      </transition>
   </div>
</template>

<script setup lang="ts">
const props = defineProps({
   name: { type: String, required: true },
   buttonClosedClasses: { type: String, default: "text-left py-6 border-t border-grey-70" },
   buttonOpenClasses: { type: String, default: "text-left py-6 border-t border-brand-dark" },
   usePlusMinusIcon: { type: Boolean }, //whether to use the plus-minus icon, instead of the arrow icon
   defaultIsExpanded: { type: Boolean },
   iconPositionLeft: { type: Boolean },
   smallerIcon: { type: Boolean },
});
const isExpanded = ref(unref(props.defaultIsExpanded));
const toggleExpand = () => {
   isExpanded.value = !isExpanded.value;
};
</script>

<style scoped lang="scss">
.expanded-enter-active,
.expanded-leave-active {
   max-height: 32rem; /* arbitrary large number */
   overflow: hidden;
   transition: max-height 0.35s ease-in-out;
}
.expanded-enter-from,
.expanded-leave-to {
   max-height: 0;
}
</style>
